export default "__VITE_ASSET__DmT7oDb___"